export default __webpack_public_path__ + "static/media/Picture11.34a12f52.png";